import React from "react";
import { useNavigate } from "react-router-dom";
import { imageUrl } from "../../config/apiUrl";
import { CardDemoImg, featuredMarker } from "../../constant/imagePath";
import Button from "../Button/Button";
import classes from "./MainCard.module.css";

function MainCard({
  status,
  data = {
    photo: CardDemoImg,
    name: "Best Basketball",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua et dolore magna aliqua et dolore magna aliqua et dolore magna aliqua.",
  },
  onClick,
  localPhoto,
  setSelectedElement,
  setIsDetailModalOpen,
}) {
  const navigate = useNavigate();
  const tags = data?.tags?.map((e) => e?.name);
  return (
    <div className={classes.card} onClick={onClick}>
      <div className={classes.imgBox}>
        <img src={localPhoto ? data?.photo : imageUrl(data?.photo)} />
      </div>
      <div className={classes.content}>
        <h5 className="t-t-c">{data?.name}</h5>
        <div style={{ color: "#fff", textTransform: "capitalize" }}>
          <b>Tags: </b>
          {tags?.join(", ")}
        </div>

        <p>{data?.description}</p>
        <div className={classes.btn_div_b}>
          {status !== true && (
            <Button
              label={"View Card"}
              isRightArrow
              primary={false}
              className={classes.btn}
              onClick={() => {
                navigate(`/cardDetail/${data?._id}`);
              }}
            />
          )}
          {status !== true && (
            <Button
              label={"Buy Now"}
              isRightArrow
              primary={false}
              className={classes.btn}
              onClick={() => {
                setSelectedElement(data);
                setIsDetailModalOpen(true);
              }}
            />
          )}
        </div>
      </div>

      {data?.isFeatured && (
        <img className={classes?.featuredMarker} src={featuredMarker} />
      )}
    </div>
  );
}

export default MainCard;
